// Groups activity-log entries by assessment round. Enterprise reassessment creates a new assessment
// row, so the log endpoint's includeChain=true returns earlier rounds too, each entry flagged with
// isFromPreviousAssessment / assessmentId / assessmentDate. Shared by the per-question history
// (QuestionHistoryToggle) and the card activity log (AssessmentActivityLog) so both label rounds
// identically.

const formatRoundDate = (ts) =>
  new Date(ts).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

// Entries newest-first, one group per round. With no earlier-round entries (every non-Enterprise
// flow, and assessments never reassessed) there is a single unlabelled group, so callers render
// exactly as before.
export function groupByAssessmentRound(entries) {
  const sorted = [...entries].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  if (!sorted.some((e) => e.isFromPreviousAssessment)) return [{ key: "current", label: null, entries: sorted }];

  const groups = new Map();
  sorted.forEach((e) => {
    const key = e.isFromPreviousAssessment ? String(e.assessmentId) : "current";
    if (!groups.has(key)) {
      const label = e.isFromPreviousAssessment
        ? `Previous assessment #${e.assessmentId}${e.assessmentDate ? ` · ${formatRoundDate(e.assessmentDate)}` : ""}`
        : "This assessment"; // not "Current": a superseded round can be opened too, and later rounds are never included
      groups.set(key, { key, label, date: e.assessmentDate, entries: [] });
    }
    groups.get(key).entries.push(e);
  });

  // The requested round first, then earlier rounds newest-first.
  return [...groups.values()].sort((a, b) => {
    if (a.key === "current") return -1;
    if (b.key === "current") return 1;
    return new Date(b.date ?? 0) - new Date(a.date ?? 0);
  });
}
